module.exports = __webpack_public_path__ + "img/3-title.4022e32b.png";